import { Do, clamp, fsmData, guid, timer } from '../../universal';
import { Mousetrap, React, _ } from '../lib';
import { objDiff } from './component-main';
import { J2rCheckbox, J2rText, J2rTooltip, j2r, j2rProps, reactFlyout, } from './component-react';
import { Bindings, CJSX, ConditionalObject, CopyState, FormType, HelpTooltip, LoadingSpinnerLarge, Modal, PromptConfirm, openFlyoutForm, setContextMenu, } from './ui5';
import Sortable from 'sortablejs';
export const useWindowManagerState = (window, input) => {
    const [state, setState] = React.useState(input);
    const update = (newState) => {
        window.updateChildState(newState);
        setState(newState);
    };
    window.setChildState = setState;
    return [state, update];
};
export class WindowManagerUI extends React.Component {
    cachedFunctions;
    windowRefs;
    canvasElement;
    mouseTrapRoot;
    fixedContent;
    fixedContentInner;
    generatedPosZ;
    UpdateThrottled;
    OnResize;
    savedSerialisedData;
    hasLaunchedFetchData;
    constructor(props) {
        super(props);
        Bindings(this, [
            this.CascadeWindows,
            this.ChangeDesktop,
            this.ChangeFocus,
            this.CloseAllOnDesktop,
            this.CloseWindow,
            this.CompactZPosition,
            this.DefaultSizes,
            this.Deserialize,
            this.Explode,
            this.GetCanvasSize,
            this.MergeDesktops,
            this.MinimizeAllOnDesktop,
            this.NewWindow,
            this.OnResizeProc,
            this.openGlobalContextMenu,
            this.refreshDesktops,
            this.Serialize,
            this.SetCover,
            this.TileWindows,
            this.Unexplode,
            this.UnexplodeNoCB,
            this.Update,
            this.UpdateProc,
        ]);
        this.state = {
            focused: null,
            hasInitData: false,
            hasInitModel: false,
            hoverBirdsEye: false,
            exploded: null,
            covered: false,
            coveredFocus: null,
            frontOverlay: null,
            frontOverlayBlurring: false,
            desktop: 1,
            desktops: [],
            windows: {},
        };
        this.cachedFunctions = {};
        this.windowRefs = {};
        this.canvasElement = React.createRef();
        this.mouseTrapRoot = React.createRef();
        this.fixedContent = React.createRef();
        this.fixedContentInner = React.createRef();
        this.generatedPosZ = 1;
        this.UpdateThrottled = _.debounce(this.UpdateProc, 1000, {
            trailing: true,
            leading: false,
        });
        this.UpdateThrottled = this.UpdateThrottled.bind(this);
        this.OnResize = _.debounce(this.OnResizeProc, 50, {
            trailing: true,
            leading: false,
        });
        this.OnResize = this.OnResize.bind(this);
        this.hasLaunchedFetchData = false;
        this.savedSerialisedData = null;
    }
    componentDidMount() {
        this.savedSerialisedData = null;
        const fnOnLoad = this.props.options?.onLoad ??
            (rs => {
                rs(null);
            });
        new Promise(fnOnLoad).then(model => {
            this.setState(this.Deserialize(model));
            this.setState({ hasInitModel: true }, () => this.props.parent.forceUpdate(() => {
                this.refreshDesktops();
                this.CompactZPosition();
            }));
        });
        const fnOnLoadData = this.props.options?.onLoadData ??
            (rs => {
                rs();
            });
        if (!this.hasLaunchedFetchData) {
            new Promise(fnOnLoadData).then(() => {
                this.setState({ hasInitData: true }, () => this.props.parent.forceUpdate(() => {
                    this.refreshDesktops();
                    this.UpdateTitle();
                }));
            });
            this.hasLaunchedFetchData = true;
        }
        this.createKeyBindings();
        const resizeThrottle = _.throttle(this.OnResize, 500);
        window.addEventListener('resize', resizeThrottle);
        this.OnResize();
        (this.props.options?.onCreate ?? _.noop)(this);
    }
    componentWillUnmount() {
        this.savedSerialisedData = this.Serialize();
        (this.props.options?.onDestroy ?? _.noop)(this);
    }
    render() {
        return (React.createElement("div", { className: Do(() => {
                let C = 'windowCanvas noselect react';
                if (this.props.options?.cl != null) {
                    C += ` ${this.props.options.cl}`;
                }
                if (this.props.options?.fixedPageContent != null) {
                    if (this.state.covered) {
                        C += ' covered';
                    }
                    if (!this.state.covered) {
                        C += ' uncovered';
                    }
                }
                return C;
            }), ref: this.mouseTrapRoot, onContextMenu: this.openGlobalContextMenu, onClick: e => {
                this.UnexplodeNoCB();
                this.closeOverlayClicked(e);
            } },
            React.createElement("div", { className: "snapping_div" }),
            React.createElement("div", { className: "backdrop noselect" },
                React.createElement(CJSX, { cond: this.state.hasInitModel },
                    React.createElement("img", { key: "backdrop-img", src: "/static/img/svg/trionline.svg" }))),
            React.createElement("div", { className: Do(() => {
                    let C = 'fixed-page canselect';
                    if (this.state.exploded != null) {
                        C += ' exploded';
                    }
                    return C;
                }), ref: this.fixedContent }, Do(() => {
                const el = (this.props.options?.fixedPageContent ?? _.noop)();
                if (el != null) {
                    return j2r(_.assign({}, el, {
                        key: 'fixed-page-inner',
                        ref: this.fixedContentInner,
                    }));
                }
                return undefined;
            })),
            React.createElement("div", { className: "fixed-page-cover" }),
            React.createElement("div", { className: Do(() => {
                    let C = 'fixed-page-stub-text';
                    if (_.size(this.windowsIterable(true)) !== 0) {
                        C += ' hidden';
                    }
                    return C;
                }) },
                React.createElement("div", { className: "inner" },
                    React.createElement("div", { className: "title" }, "No open windows"),
                    React.createElement("div", { className: "subtitle" }, "Click anywhere to close overlay"))),
            React.createElement("div", { className: Do(() => {
                    let C = 'windowCanvas';
                    if (this.state.exploded != null) {
                        C += ' exploded';
                    }
                    if (this.state.hoverBirdsEye && this.state.exploded == null) {
                        C += ' birdhover';
                    }
                    if (this.state.frontOverlayBlurring) {
                        C += ' blurred';
                    }
                    return C;
                }), tabIndex: -1, ref: this.canvasElement, onScroll: e => {
                    e.currentTarget.scrollTop = 0;
                } }, Do(() => {
                if (!this.state.hasInitModel) {
                    return React.createElement(LoadingSpinnerLarge, { key: "loading" });
                }
                return j2r(_.compact(_.flatten([
                    this.buildWindows(),
                    (this.state.exploded ?? []).map(e => (React.createElement("div", { className: "explode-handler", key: `explode-handler-${e.o.state.key}`, style: {
                            left: `${e.x}px`,
                            top: `${e.y}px`,
                            width: `${e.w}px`,
                            height: `${e.h}px`,
                        }, onClick: () => {
                            this.Unexplode(() => {
                                this.ChangeFocus(e.o.state.key);
                            });
                        } },
                        React.createElement("span", null, Do(() => {
                            const fn = this.cachedFunctions[e.o.props.title ?? ''] ?? _.noop;
                            return ((_.isFunction(fn)
                                ? fn(e.o.state.params ??
                                    {}, e.o)
                                : fn) ?? 'No Title');
                        }))))),
                ])));
            })),
            React.createElement("div", { className: Do(() => {
                    let C = 'window-front-overlay';
                    if (this.state.frontOverlay != null) {
                        C += ' has-contents';
                    }
                    return C;
                }) }, ConditionalObject(this.state.frontOverlay != null, () => j2r(_.assign({ key: 'inner' }, this.state.frontOverlay))))));
    }
    buildWindows() {
        return fsmData(this.state.windows, {
            sort: x => x.key,
            map: x => (React.createElement(WindowManagerWindow, { ...x, parent: this, isLoading: !this.state.hasInitData, ref: Do(() => {
                    if (this.windowRefs[x.key] == null) {
                        this.windowRefs[x.key] = React.createRef();
                    }
                    return this.windowRefs[x.key];
                }), isFocused: +x.key === +(this.state.focused ?? ''), index: Number(x.key), key: x.key, lastForcedReactUpdate: window.lastForcedReactUpdate })),
        });
    }
    windowsIterable(desktop_only = false) {
        const objs = {};
        _.keys(this.state.windows).forEach(x => {
            const obj = this.windowRefs[x]?.current;
            if (obj != null &&
                !(desktop_only && obj.state.pos.d !== this.state.desktop)) {
                objs[x] = obj;
            }
        });
        return objs;
    }
    getWindow(key) {
        const windows = this.windowsIterable();
        const keyStr = typeof key === 'string' ? key : String(key);
        return windows[keyStr];
    }
    refreshDesktops() {
        if (!this.state.hasInitModel) {
            return;
        }
        const used_desktops = _.uniq(_.map(this.windowsIterable(), w => w.state.pos.d));
        const to_add = [];
        used_desktops.forEach(d => {
            const found = this.state.desktops.filter(x => x.key === d);
            if (_.size(found) === 0) {
                to_add.push({
                    key: d,
                    index: to_add.length + 1,
                    name: null,
                });
            }
        });
        const empty_desktops = fsmData(this.state.desktops, {
            filter: d => {
                if (d.name != null) {
                    return false;
                }
                const matches = _.filter(this.windowsIterable(), w => w.state.pos.d === d.key);
                return matches.length === 0;
            },
            sort: d => d.key,
            map: d => d.key,
        });
        const desktops_to_remove = empty_desktops.slice(1);
        let new_desktops = this.state.desktops
            .concat(to_add)
            .filter(d => !_.includes(desktops_to_remove, d.key));
        if (empty_desktops.length === 0) {
            const used = new_desktops.map(x => x.key);
            _.forEach(_.range(1, 10), x => {
                if (!_.includes(used, x)) {
                    new_desktops = new_desktops.concat({
                        key: x,
                        index: new_desktops.length + 1,
                        name: null,
                    });
                    return false;
                }
                return true;
            });
        }
        const matches = new_desktops.filter(x => x.key === this.state.desktop);
        const desktop = matches.length === 0 ? 1 : this.state.desktop;
        new_desktops = fsmData(new_desktops, {
            sort: x => x.index,
            map: (x, i) => ({
                key: x.key,
                index: i + 1,
                name: x.name || null,
            }),
        });
        if (_.isEqual(this.state.desktops, new_desktops) &&
            desktop === this.state.desktop) {
            return;
        }
        this.setState({
            desktops: new_desktops,
            desktop,
        }, () => {
            this.Update();
        });
    }
    deserializeWindows(w) {
        const extractXY = (v) => {
            if (v == null) {
                return {};
            }
            if (Array.isArray(v)) {
                return { x: v[0], y: v[1] };
            }
            return { x: v.x, y: v.y };
        };
        const getSize = (s, fb) => {
            const sXY = extractXY(s);
            const fbXY = extractXY(fb);
            return { x: sXY.x ?? fbXY.x ?? 0, y: sXY.y ?? fbXY.y ?? 0 };
        };
        const windows = {};
        let last_key = null;
        _.forEach(w, (x, i) => {
            const key = i + 1;
            const props = {
                params: x.params,
                pos: x.pos,
                size: x.size,
                preMaximMinimPos: x.preMaximMinimPos,
                preMaximMinimSize: x.preMaximMinimSize,
                isMinimized: x.isMinimized,
                isMaximized: x.isMaximized,
            };
            const fn = this.getFunction(x.func);
            if (fn == null) {
                return;
            }
            const defaultProps = fn(x.params);
            const fn_content_key = guid();
            const fn_title_key = guid();
            this.cachedFunctions[fn_title_key] = defaultProps.title;
            this.cachedFunctions[fn_content_key] = this.getContentFunction(defaultProps);
            const wobj = {
                ...defaultProps,
                ...props,
                tag: WindowManagerWindow,
                parent: this,
                title: fn_title_key,
                content: fn_content_key,
                ref: Do(() => {
                    if (this.windowRefs[key] == null) {
                        this.windowRefs[key] = React.createRef();
                    }
                    return this.windowRefs[key];
                }),
                index: key,
                key: String(key),
            };
            wobj.sizeDef = getSize(defaultProps.size, [640, 480]);
            wobj.sizeMax = getSize(wobj.sizeMax, [99999, 99999]);
            wobj.sizeMin = getSize(wobj.sizeMin, [240, 28]);
            if (this.props.options?.disableVirtualDesktops) {
                wobj.pos.d = 1;
            }
            const keyString = String(key);
            windows[keyString] = wobj;
            last_key = keyString;
        });
        this.setState({ focused: last_key });
        return windows;
    }
    getFunction(s) {
        if (!s) {
            return null;
        }
        if (this.props.options?.namespace != null) {
            s = `${this.props.options.namespace}.${s}`;
        }
        const parts = s.split('.');
        let currNamespace = window;
        let currNamespaceStr = 'window';
        _.forEach(parts, part => {
            currNamespace = currNamespace[part];
            if (currNamespace == null) {
                console.error(`Could not find ${currNamespaceStr}.${part}`);
                currNamespace = null;
                return false;
            }
            currNamespaceStr += `.${part}`;
            return true;
        });
        return currNamespace;
    }
    getNextPosZ() {
        let i = this.generatedPosZ;
        this.generatedPosZ++;
        const max_z = _.max(_.map(this.windowsIterable(), x => x.state.pos.z)) ?? 0;
        if (max_z >= i) {
            this.generatedPosZ = max_z + 1;
            i = this.generatedPosZ;
            this.generatedPosZ++;
        }
        return i;
    }
    getNextPosFull() {
        return [
            10 + 20 * this.generatedPosZ,
            10 + 20 * this.generatedPosZ,
        ];
    }
    createKeyBindings() {
        const isFocusingInput = () => {
            const el = document.querySelector(':focus');
            return el?.tagName && ['TEXTAREA', 'INPUT'].includes(el.tagName);
        };
        const canvas = Mousetrap(this.mouseTrapRoot.current ?? undefined);
        {
            const changeVirtualDesktop = (e) => {
                if (!isFocusingInput()) {
                    let index = e.which - 48;
                    if (index === 0) {
                        index = 10;
                    }
                    this.ChangeDesktop(index);
                }
            };
            canvas.bind('d 1', changeVirtualDesktop);
            canvas.bind('d 2', changeVirtualDesktop);
            canvas.bind('d 3', changeVirtualDesktop);
            canvas.bind('d 4', changeVirtualDesktop);
            canvas.bind('d 5', changeVirtualDesktop);
            canvas.bind('d 6', changeVirtualDesktop);
            canvas.bind('d 7', changeVirtualDesktop);
            canvas.bind('d 8', changeVirtualDesktop);
            canvas.bind('d 9', changeVirtualDesktop);
            canvas.bind('d 0', changeVirtualDesktop);
            canvas.bind('d left', () => {
                if (!isFocusingInput()) {
                    const new_key = clamp(this.state.desktop - 1, 1, 10);
                    this.ChangeDesktop(new_key);
                }
            });
            canvas.bind('d left', () => {
                if (!isFocusingInput()) {
                    const new_key = clamp(this.state.desktop + 1, 1, 10);
                    this.ChangeDesktop(new_key);
                }
            });
        }
        {
            const tile = (e) => {
                if (!isFocusingInput()) {
                    const index = e.which - 48;
                    if (index === 0) {
                        this.CascadeWindows();
                    }
                    else {
                        this.TileWindows(index);
                    }
                }
            };
            canvas.bind('t 0', tile);
            canvas.bind('t 1', tile);
            canvas.bind('t 2', tile);
            canvas.bind('t 3', tile);
            canvas.bind('t 4', tile);
            canvas.bind('t 5', tile);
            canvas.bind('t 6', tile);
        }
        canvas.bind('f f', () => {
            if (!isFocusingInput()) {
                this.FanOutWindows();
            }
        });
        canvas.bind('b b', () => {
            if (!isFocusingInput()) {
                this.Explode();
            }
        });
        canvas.bind('o o', () => {
            if (!isFocusingInput()) {
                this.SetCover();
            }
        });
        canvas.bind('m m', () => {
            if (!isFocusingInput()) {
                this.MinimizeAllOnDesktop();
            }
        });
        canvas.bind('x x', () => {
            if (!isFocusingInput()) {
                this.ExpandAllOnDesktop();
            }
        });
        canvas.bind('c c', () => {
            if (!isFocusingInput()) {
                this.CloseAllOnDesktop();
            }
        });
        if (this.fixedContent.current != null) {
            Mousetrap(this.fixedContent.current).bind('o o', () => {
                if (!isFocusingInput()) {
                    this.SetCover();
                }
            });
        }
    }
    closeOverlayClicked(e) {
        if (!(e.target instanceof Element) ||
            !e.target.classList.contains('windowCanvas')) {
            return;
        }
        if (this.props.options?.fixedPageContent == null) {
            return;
        }
        this.SetCover(false);
    }
    openGlobalContextMenu(e) {
        if (!(e.target instanceof Element) ||
            !e.target.classList.contains('windowCanvas')) {
            return;
        }
        e.preventDefault();
        this.openGlobalContextMenuInner({
            x: e.clientX,
            y: e.clientY,
        });
    }
    openGlobalContextMenuInner({ x, y }) {
        setContextMenu({
            position: { x, y },
            width: 184,
            items: _.compact(_.flatten([
                {
                    label: 'Toggle birds-eye',
                    shortcut: 'B B',
                    onClick: this.Explode,
                },
                ConditionalObject(this.props.options?.fixedPageContent != null, {
                    label: 'Toggle overlay',
                    shortcut: 'O O',
                    onClick: () => {
                        this.SetCover();
                    },
                }),
                '---',
                ConditionalObject(window.innerWidth <= 1024 &&
                    !this.props.options?.disableVirtualDesktops, () => ({
                    label: 'Switch Desktop',
                    items: this.state.desktops.map(x => ({
                        label: x.name ?? `Desktop ${x.key}`,
                        icon: ConditionalObject(this.state.desktop === x.key, '/static/img/i8/material-outline-checkmark.svg'),
                        onClick: () => {
                            this.ChangeDesktop(x.key);
                        },
                    })),
                })),
                ConditionalObject(!this.props.options?.disableVirtualDesktops, () => [
                    {
                        label: 'Move all',
                        childWidth: 160,
                        items: this.state.desktops.map(x => ({
                            label: x.name ?? `Desktop ${x.key}`,
                            onClick: () => {
                                this.MoveWindowsToDesktop(x.key);
                            },
                        })),
                    },
                    {
                        label: 'Merge desktops',
                        onClick: this.MergeDesktops,
                    },
                    '---',
                ]),
                {
                    label: 'Cascade all',
                    shortcut: 'T 0',
                    onClick: this.CascadeWindows,
                },
                {
                    label: 'Default sizes',
                    shortcut: 'T 0',
                    onClick: this.DefaultSizes,
                },
                {
                    label: 'Fan-out',
                    hidden: true,
                    shortcut: 'F F',
                    onClick: this.FanOutWindows,
                },
                {
                    label: 'Tile all',
                    childWidth: 160,
                    items: [1, 2, 3, 4].map(i => ({
                        label: `Rows: ${i}`,
                        shortcut: `T ${i}`,
                        onClick: () => {
                            this.TileWindows(i);
                        },
                    })),
                },
                {
                    label: 'Minimise all',
                    shortcut: 'M M',
                    onClick: this.MinimizeAllOnDesktop,
                },
                '---',
                {
                    label: 'Close all',
                    shortcut: 'C C',
                    onClick: this.CloseAllOnDesktop,
                },
            ])),
        });
    }
    getMinimizeCoords(required) {
        const spacing = { x: 205, y: 32 };
        const padding = 5;
        const canvas = this.GetCanvasSize();
        const windows_on_desktop = this.windowsIterable(true);
        const heights = fsmData(windows_on_desktop, {
            filter: w => w.state.isMinimized,
            sort: w => w.state.pos.y,
            map: w => w.state.pos.y,
        });
        const widths = fsmData(windows_on_desktop, {
            filter: w => w.state.isMinimized,
            sort: w => w.state.pos.x,
            map: w => w.state.pos.x,
        });
        let [x, y] = [padding, padding];
        const results = [];
        while (x < canvas.x - spacing.x - padding) {
            while (y < canvas.y - spacing.y - padding) {
                if (!heights.includes(y) || !widths.includes(x)) {
                    results.push({ x, y });
                    if (results.length >= required) {
                        return results;
                    }
                }
                y += spacing.y;
            }
            x += spacing.x;
            y = padding;
        }
        console.error('Could not find anywhere to put the window...', results, { x, y });
        return results;
    }
    getContentFunction(properties) {
        if (properties['content'] != null) {
            if (properties['cmpt'] != null) {
                console.error('A `content` and `cmpt` function is defined - pick one');
            }
            return properties['content'];
        }
        return (p) => {
            const params = {};
            _.forEach(properties['fields'], (k) => {
                if (p && typeof k === 'string') {
                    params[k] = p[k];
                }
            });
            return {
                tag: properties['cmpt'],
                _fields: properties['fields'],
                ...params,
            };
        };
    }
    setFrontOverlay(blurring, elements) {
        this.setState({
            frontOverlayBlurring: blurring,
            frontOverlay: elements,
        });
    }
    removeFrontOverlay() {
        this.setState({
            frontOverlayBlurring: false,
            frontOverlay: null,
        });
    }
    GetCanvasSize() {
        if (this.canvasElement.current != null && window.innerWidth >= 768) {
            const rect = this.canvasElement.current.getBoundingClientRect();
            return { x: rect.width, y: rect.height };
        }
        return { x: 999999, y: 999999 };
    }
    OnResizeProc() {
        _.map(this.windowsIterable(), w => {
            w.ConfirmValidPosSize();
        });
        timer(() => {
            this.forceUpdate();
        });
    }
    NewWindow(fn, params, cb = _.noop) {
        this.Unexplode();
        const properties = fn(params ?? {});
        const clash_window = fsmData(this.windowsIterable(), {
            filter: x => x.state.sid != null && x.state.sid === properties.sid,
            takeFirst: true,
        });
        if (clash_window != null) {
            const focusPulse = () => {
                clash_window.Focus();
                clash_window.Pulse();
                if (params != null) {
                    clash_window.setState({ params: params });
                }
            };
            if (this.state.desktop !== clash_window.state.pos.d) {
                this.ChangeDesktop(clash_window.state.pos.d, () => timer(200, focusPulse));
            }
            else {
                timer(focusPulse);
            }
            this.SetCover(true, clash_window.state.key);
            return;
        }
        const fn_content_key = guid();
        const fn_title_key = guid();
        this.cachedFunctions[fn_title_key] = properties.title;
        this.cachedFunctions[fn_content_key] = this.getContentFunction(properties);
        const getPos = (p, fb) => ({
            x: p?.[0] ?? fb?.[0] ?? 0,
            y: p?.[1] ?? fb?.[1] ?? 0,
            z: this.getNextPosZ(),
            d: this.state.desktop,
        });
        const getPrePos = (p, fb) => ({
            x: p?.[0] ?? fb?.[0] ?? 0,
            y: p?.[1] ?? fb?.[1] ?? 0,
            z: this.getNextPosZ(),
            d: this.state.desktop,
        });
        const getSize = (s, fb) => ({
            x: s?.[0] ?? fb?.[0] ?? 0,
            y: s?.[1] ?? fb?.[1] ?? 0,
        });
        const normalizeSize = (s, fb) => {
            if (s == null) {
                return undefined;
            }
            return [s[0] ?? fb[0], s[1] ?? fb[1]];
        };
        const max_key = _.max(_.map(_.keys(this.state.windows), x => +x));
        const key = (max_key || 0) + 1;
        const newWindow = {
            ...properties,
            tag: WindowManagerWindow,
            title: fn_title_key,
            content: fn_content_key,
            parent: this,
            params: params ?? {},
            ref: Do(() => {
                if (this.windowRefs[key] == null) {
                    this.windowRefs[key] = React.createRef();
                }
                return this.windowRefs[key];
            }),
            index: key,
            key: String(key),
            sid: properties.sid ?? null,
            cl: properties.cl ?? '',
            preMaximMinimSize: getSize(properties.size),
            preMaximMinimPos: getPrePos(this.getNextPosFull()),
            pos: getPos(properties.pos ?? this.getNextPosFull()),
            sizeDef: getSize(properties.size),
            size: getSize(properties.size, [640, 480]),
            sizeMax: getSize(normalizeSize(properties.sizeMax, [99999, 99999]), [99999, 99999]),
            sizeMin: getSize(normalizeSize(properties.sizeMin, [240, 28]), [240, 28]),
        };
        const keyString = String(key);
        this.SetCover(true, keyString);
        this.setState({
            windows: {
                ...this.state.windows,
                [keyString]: newWindow,
            },
        }, () => {
            this.Update();
            this.ChangeFocus(keyString);
            const window = this.getWindow(keyString);
            if (window != null) {
                cb(window);
            }
        });
    }
    CloseWindow(key) {
        this.state.windows[key]?.ref.current?.SetOpacity(0);
        timer(200, () => {
            const delta = (s) => ({
                windows: _.omit(s.windows, [key]),
            });
            this.setState(delta, () => {
                const new_focus = fsmData(this.windowsIterable(true), {
                    sort: x => x.state.pos.z,
                    reverse: true,
                    takeFirst: true,
                    map: x => x?.state.key ?? null,
                });
                this.ChangeFocus(new_focus, () => {
                    this.Update();
                    if (new_focus == null) {
                        this.SetCover(false);
                    }
                });
            });
        });
        if (this.state.coveredFocus === key) {
            this.SetCover(false);
        }
    }
    CloseAllOnDesktop() {
        _.forEach(this.windowsIterable(true), x => {
            this.CloseWindow(x.state.key);
        });
    }
    CompactZPosition() {
        let highest_z = 0;
        fsmData(this.windowsIterable(), {
            sort: x => x.state.pos.z,
            map: (x, i) => {
                highest_z = i + 1;
                x.update(() => ({
                    pos: {
                        z: highest_z,
                    },
                }));
            },
        });
        this.generatedPosZ = highest_z;
    }
    ChangeFocus(key, cb) {
        this.setState(s => {
            if (key === s.focused) {
                return null;
            }
            const d = CopyState(s);
            d.focused = key;
            if (key !== s.coveredFocus) {
                d.coveredFocus = null;
            }
            return d;
        }, () => {
            this.windowRefs[key ?? '']?.current?.update(() => ({
                pos: { z: this.getNextPosZ() },
            }));
            this.windowRefs[key ?? '']?.current?.onFocus();
            this.UpdateTitle();
            (cb ?? _.noop)();
        });
    }
    UpdateTitle() {
        let title;
        const focusedKey = this.state.focused;
        if (focusedKey != null) {
            title = this.state.covered
                ? this.windowRefs[focusedKey]?.current?.getTitle()
                : this.fixedContentInner.current?.getTitle?.();
        }
        else {
            title = this.fixedContentInner.current?.getTitle?.();
        }
        if (title == null) {
            title = window.rootData.Title;
        }
        title = (this.props.options?.getTitle ?? _.identity)(title);
        document.title = `${title} | TriOnline`;
    }
    Serialize() {
        const windows = this.windowsIterable();
        return (this.savedSerialisedData ?? {
            desktop: this.state.desktop,
            desktops: this.state.desktops,
            windows: fsmData(windows, {
                sort: x => x.state.pos.z,
                map: x => ({
                    func: x.state.func,
                    params: x.state.params,
                    pos: x.state.pos,
                    size: x.state.size,
                    sizeDef: x.state.sizeDef,
                    preMaximMinimSize: x.state.preMaximMinimSize,
                    preMaximMinimPos: x.state.preMaximMinimPos,
                    isMinimized: x.state.isMinimized,
                    isMaximized: x.state.isMaximized,
                }),
            }),
            covered: Do(() => {
                if (_.size(windows) === 0) {
                    return false;
                }
                return this.state.covered;
            }),
        });
    }
    Deserialize(state) {
        const parsedState = typeof state === 'string' ? JSON.parse(state) : state;
        return {
            focused: null,
            hasInitData: false,
            hasInitModel: false,
            hoverBirdsEye: false,
            exploded: null,
            windows: this.deserializeWindows(parsedState?.windows ?? []),
            covered: parsedState?.covered ?? false,
            coveredFocus: null,
            frontOverlay: null,
            frontOverlayBlurring: false,
            desktops: parsedState?.desktops || [
                {
                    key: 1,
                    index: 1,
                    name: null,
                },
            ],
            desktop: Do(() => {
                if (this.props.options?.disableVirtualDesktops) {
                    return 1;
                }
                return parsedState?.desktop ?? 1;
            }),
        };
    }
    UpdateProc() {
        const save_state = this.Serialize();
        (this.props.options?.onSave ?? _.noop)(save_state);
    }
    Update() {
        this.refreshDesktops();
        this.UpdateThrottled();
        this.props.toolbar?.forceUpdate();
    }
    SetCover(x, focus_key) {
        this.setState((s) => {
            if (x === s.covered) {
                return null;
            }
            return {
                covered: x ?? !s.covered,
                coveredFocus: focus_key ?? null,
            };
        });
        this.UpdateThrottled();
    }
    Explode() {
        this.SetCover(true);
        if (this.state.exploded != null) {
            this.Unexplode();
            return;
        }
        const canvas = this.GetCanvasSize();
        const padding_x = 10;
        const padding_y = 10;
        const peek_offset = 30;
        let row_height = Math.floor((canvas.y - padding_y * 2 - peek_offset) / 2);
        row_height = clamp(row_height, 200, 400);
        const getRowOffset = (row) => row * (row_height + padding_y) + padding_y;
        const row_width = canvas.x - padding_x * 2;
        let current_row = 0;
        let current_pixels = padding_x;
        const coords = fsmData(this.windowsIterable(true), {
            sort: x => 10000 - x.state.pos.z,
            map: x => {
                let multiplier = row_height / x.state.size.y;
                multiplier = Math.min(multiplier, 1);
                const horizontal_used = x.state.size.x * multiplier;
                if (current_pixels + horizontal_used > row_width) {
                    current_row += 1;
                    current_pixels = padding_x;
                }
                const horizontal_offset = current_pixels;
                current_pixels += horizontal_used + padding_x;
                return {
                    wobj: x,
                    multiplier,
                    size: {
                        x: horizontal_used,
                        y: x.state.size.y * multiplier,
                    },
                    pos: {
                        x: horizontal_offset,
                        y: getRowOffset(current_row),
                        z: x.state.pos.z,
                        d: x.state.pos.d,
                    },
                    preMaximMinimPos: {
                        x: horizontal_offset,
                        y: getRowOffset(current_row),
                        z: x.state.pos.z,
                        d: x.state.pos.d,
                    },
                    offset: {
                        x: horizontal_offset - x.state.pos.x,
                        y: getRowOffset(current_row) - x.state.pos.y,
                    },
                };
            },
        });
        coords.forEach(w => {
            w.wobj.setState({
                transform: Do(() => {
                    const [x, y, m] = [w.offset.x, w.offset.y, w.multiplier];
                    return `translate(${x}px, ${y}px) scale(${m})`;
                }),
            });
        });
        const delta = {
            exploded: coords.map(w => ({
                o: w.wobj,
                x: w.pos.x,
                y: w.pos.y,
                w: w.size.x,
                h: w.size.y,
            })),
        };
        this.setState(delta, () => this.props.toolbar?.forceUpdate());
    }
    UnexplodeNoCB() {
        this.Unexplode();
    }
    Unexplode(cb) {
        if (this.state.exploded == null) {
            cb?.();
            return;
        }
        _.forEach(this.windowsIterable(), wobj => {
            wobj.setState({ transform: null });
            wobj.onResizeEvent();
        });
        this.setState({ exploded: null }, () => {
            if (this.canvasElement.current != null) {
                this.canvasElement.current.scrollTop = 0;
            }
            this.props.toolbar?.forceUpdate();
            (cb ?? _.noop)();
        });
    }
    ChangeDesktop(key, cb) {
        window.lastForcedReactUpdate = _.now();
        this.setState({ desktop: key }, () => {
            this.Unexplode(() => {
                this.Update();
                cb?.();
            });
        });
    }
    MoveWindowsToDesktop(key) {
        const windows = this.windowsIterable(true);
        this.ChangeDesktop(key);
        _.forEach(windows, w => {
            w.update(() => ({ pos: { d: key } }));
        });
    }
    MinimizeAllOnDesktop() {
        const windowsToMinimise = _.filter(this.windowsIterable(true), w => !w.state.isMinimized);
        const coords = this.getMinimizeCoords(windowsToMinimise.length);
        windowsToMinimise.forEach((w, i) => {
            w.minimize(coords[i]);
        });
    }
    ExpandAllOnDesktop() {
        _.forEach(this.windowsIterable(true), w => {
            if (!w.state.isMaximized) {
                w.maximizeRestore();
            }
        });
    }
    MergeDesktops() {
        _.forEach(this.windowsIterable(), w => {
            w.update(() => ({ pos: { d: this.state.desktop } }));
        });
        this.setState(s => ({
            desktops: s.desktops.filter(d => d.key === this.state.desktop),
        }), () => {
            this.Update();
        });
    }
    CascadeWindows() {
        let currX = 10;
        let currY = 10;
        const dx = 60;
        const dy = 26;
        fsmData(this.windowsIterable(true), {
            sort: w => w.state.pos.z,
            map: w => {
                const [x, y] = [currX + 0, currY + 0];
                w.update(() => ({
                    isMinimized: false,
                    isMaximized: false,
                    pos: { x, y, z: w.state.pos.z, d: w.state.pos.d },
                    preMaximMinimPos: { x, y, z: w.state.pos.z, d: w.state.pos.d },
                    size: w.state.sizeDef,
                }));
                currX += dx;
                currY += dy;
            },
        });
    }
    DefaultSizes() {
        _.forEach(this.windowsIterable(true), w => {
            if (!w.state.isMinimized) {
                w.update(() => ({ size: w.state.sizeDef }));
            }
        });
    }
    TileWindows(rows) {
        const windows = _.sortBy(this.windowsIterable(true), (x) => 10000 - x.state.pos.z);
        const cols = Math.ceil(windows.length / rows);
        const canvas = this.GetCanvasSize();
        const box_height = canvas.y / rows;
        const box_width = canvas.x / cols;
        windows.forEach((wobj, index) => {
            const row_index = index % rows;
            const col_index = Math.floor(index / rows);
            wobj.update(() => ({
                isMinimized: false,
                isMaximized: false,
                size: {
                    x: Math.round(box_width),
                    y: Math.round(box_height),
                },
                pos: {
                    x: Math.round(box_width * col_index),
                    y: Math.round(box_height * row_index),
                    z: wobj.state.pos.z,
                    d: wobj.state.pos.d,
                },
                preMaximMinimPos: {
                    x: Math.round(box_width * col_index),
                    y: Math.round(box_height * row_index),
                    z: wobj.state.pos.z,
                    d: wobj.state.pos.d,
                },
            }));
        });
    }
    FanOutWindows() {
        console.log('Fanning-out windows');
    }
    ChangeDesktopName(key, index, name) {
        this.setState(s => ({
            desktops: s.desktops.map(desktop => {
                if (desktop.key === key) {
                    return {
                        key,
                        index,
                        name: name || null,
                    };
                }
                return desktop;
            }),
        }), () => {
            this.Update();
        });
    }
    DeleteDesktop(key) {
        fsmData(this.windowsIterable(), {
            filter: x => x.state.pos.d === key,
            map: x => {
                x.Close();
            },
        });
        this.setState(s => ({
            desktops: s.desktops.filter(d => d.key !== key),
        }), () => {
            this.Update();
        });
    }
}
export class WindowManagerToolbar extends React.Component {
    vdesktops;
    sortableObj;
    constructor(props) {
        super(props);
        Bindings(this, [this.openGlobalContextMenu]);
        this.vdesktops = React.createRef();
        this.sortableObj = null;
    }
    componentDidMount() {
        if (this.vdesktops.current == null) {
            return;
        }
        this.sortableObj = Sortable.create(this.vdesktops.current, {
            animation: 200,
            direction: 'horizontal',
            onEnd: () => {
                console.warn('Sorting desktops not yet implemented');
            },
        });
    }
    componentWillUnmount() {
        this.sortableObj?.destroy();
    }
    render() {
        return j2r({
            cl: 'window-manager-toolbar',
            children: [
                ConditionalObject(window.innerWidth > 1024 &&
                    this.props.wmanager.props.options?.fixedPageContent != null, {
                    tag: J2rTooltip,
                    title: 'Toggle overlays',
                    key: 'toggle-overlay',
                    id: 'toggle-overlay',
                    content: [
                        {
                            tag: 'span',
                            key: 'img-outer',
                            children: [
                                {
                                    tag: 'img',
                                    key: 'bot',
                                    cl: 'overlay-piece bot',
                                    src: '/static/img/svg/overlay-piece.svg',
                                },
                                {
                                    tag: 'img',
                                    key: 'mid',
                                    cl: 'overlay-piece mid',
                                    src: '/static/img/svg/overlay-piece.svg',
                                },
                                {
                                    tag: 'img',
                                    key: 'top',
                                    cl: 'overlay-piece top',
                                    src: '/static/img/svg/overlay-piece.svg',
                                },
                            ],
                        },
                    ],
                    onContextMenu: this.openGlobalContextMenu,
                    onClick: () => {
                        this.props.wmanager.SetCover();
                    },
                }),
                ConditionalObject(window.innerWidth > 1024 &&
                    !this.props.wmanager.props.options?.disableVirtualDesktops, {
                    key: 'vdesktops',
                    id: 'vdesktops',
                    ref: this.vdesktops,
                    children: fsmData(this.props.wmanager.state.desktops ?? [], {
                        sort: x => x.index,
                        map: x => this.buildDesktopIndicator(x),
                    }),
                }),
                ConditionalObject(!this.props.wmanager.props.options?.disableBirdsEyeButton, {
                    tag: J2rTooltip,
                    title: 'Birds-Eye View',
                    key: 'birds-eye',
                    id: 'btnBirdsEye',
                    cl: Do(() => {
                        let C = 'birds-eye-button';
                        if (this.props.wmanager.state.exploded != null) {
                            C += ' exploded';
                        }
                        return C;
                    }),
                    content: [
                        {
                            tag: 'span',
                            key: 'img-outer',
                            children: [
                                {
                                    tag: 'img',
                                    key: 'bl',
                                    cl: 'explode-part bl fade-in',
                                    src: '/static/img/svg/explode-part.svg',
                                },
                                {
                                    tag: 'img',
                                    key: 'tr',
                                    cl: 'explode-part tr fade-in',
                                    src: '/static/img/svg/explode-part.svg',
                                },
                                {
                                    tag: 'img',
                                    key: 'lhs',
                                    cl: 'explode-part lhs',
                                    src: '/static/img/svg/explode-part.svg',
                                },
                                {
                                    tag: 'img',
                                    key: 'rhs',
                                    cl: 'explode-part rhs',
                                    src: '/static/img/svg/explode-part.svg',
                                },
                            ],
                            onMouseEnter: () => {
                                this.props.wmanager.setState({
                                    hoverBirdsEye: true,
                                });
                            },
                            onMouseLeave: () => {
                                this.props.wmanager.setState({
                                    hoverBirdsEye: false,
                                });
                            },
                        },
                    ],
                    onContextMenu: this.openGlobalContextMenu,
                    onClick: (e) => {
                        if (window.innerWidth <= 1024) {
                            this.openGlobalContextMenu(e);
                        }
                        else {
                            this.props.wmanager.Explode();
                        }
                    },
                }),
            ],
        });
    }
    buildDesktopIndicator(desktop) {
        return {
            tag: J2rTooltip,
            key: desktop.key,
            cl: Do(() => {
                let C = 'vdIndicator';
                if (this.props.wmanager.state.desktop === desktop.key) {
                    C += ' selected';
                }
                return C;
            }),
            title: `Open Virtual Desktop #${desktop.index}`,
            options: { delay: 2000 },
            content: [
                {
                    tag: 'span',
                    key: 'label',
                    cl: 'label',
                    text: desktop.name ?? desktop.index,
                },
                {
                    tag: 'span',
                    key: 'count',
                    cl: 'count',
                    text: Do(() => {
                        const ws = this.props.wmanager.windowsIterable();
                        const count = _.size(_.filter(ws, w => w.state.pos.d === desktop.key));
                        return String(count || '');
                    }),
                },
            ],
            onClick: () => {
                this.props.wmanager.ChangeDesktop(desktop.key);
            },
            onContextMenu: (e) => {
                e.preventDefault();
                setContextMenu({
                    position: {
                        x: e.clientX,
                        y: e.clientY,
                    },
                    width: 120,
                    items: [
                        {
                            label: 'Rename',
                            icon: '/static/img/edit.png',
                            onClick: () => {
                                this.renameDesktop(desktop.key, desktop.name);
                            },
                        },
                        {
                            label: 'Delete',
                            icon: '/static/img/cross.png',
                            onClick: () => {
                                this.deleteDesktop(desktop.key);
                            },
                        },
                    ],
                });
            },
        };
    }
    openGlobalContextMenu(e) {
        e.preventDefault();
        this.props.wmanager.openGlobalContextMenuInner({
            x: e.clientX,
            y: e.clientY,
        });
    }
    renameDesktop(key, existing_name) {
        openFlyoutForm({
            title: 'Edit Desktop Name',
            size: [270, null],
            lblWidth: 50,
            buttonWidth: 110,
            fields: {
                name: FormType.Text({
                    lbl: 'Name',
                    def: () => existing_name ?? '',
                    placeholder: `Desktop #${key} name`,
                    maxLength: 20,
                }),
            },
            formPrompt: 'The user is entering the name for a virtual desktop',
            onSave: (model, cb) => {
                const index = fsmData(this.props.wmanager.state.desktops ?? [], {
                    filter: x => x.key === key,
                    takeFirst: true,
                    map: x => x?.index,
                });
                if (!index) {
                    cb('Invalid desktop');
                    return;
                }
                this.props.wmanager.ChangeDesktopName(key, index, model.current.name);
                cb(true);
            },
        });
    }
    deleteDesktop(key) {
        PromptConfirm({
            msg: (React.createElement(React.Fragment, null, "Deleting this desktop will close all its windows and remove any custom name. Are you sure?")),
            yes: done => {
                this.props.wmanager.DeleteDesktop(key);
                done(true);
            },
        });
    }
}
export class WindowManagerWindow extends React.PureComponent {
    rootEl;
    contentComponent;
    checkNotNeeded;
    onResizeEvent;
    setChildState;
    constructor(props) {
        super(props);
        Bindings(this, [
            this.Close,
            this.ConfirmValidPosSize,
            this.contextMenuTitlebar,
            this.dragStart,
            this.dragEvent,
            this.dragEnd,
            this.Focus,
            this.GetContent,
            this.kebabClick,
            this.maximizeRestore,
            this.minimize,
            this.openKebabMenu,
            this.Pulse,
            this.setToDefaultSize,
            this.snap,
            this.update,
            this.UpdateCreationState,
            this.UpdateSID,
            this.UpdatePositionSize,
        ]);
        this.rootEl = React.createRef();
        this.contentComponent = React.createRef();
        this.checkNotNeeded = false;
        this.onResizeEvent = _.debounce(this.onResizeEventProc, 100, {
            trailing: true,
            leading: false,
        });
        const state = {
            key: String(this.props.index),
            func: this.props.func,
            params: this.props.params ?? {},
            sid: this.props.sid ?? null,
            size: this.props.size ?? { x: 640, y: 480 },
            sizeMax: this.props.sizeMax ?? { x: 99999, y: 99999 },
            sizeMin: this.props.sizeMin ?? { x: 240, y: 28 },
            sizeDef: this.props.sizeDef ?? this.props.size ?? { x: 640, y: 480 },
            preMaximMinimSize: this.props.preMaximMinimSize ??
                this.props.size ?? { x: 640, y: 480 },
            pos: this.props.pos ?? { x: 0, y: 0, z: 1, d: 1 },
            preMaximMinimPos: this.props.preMaximMinimPos ??
                this.props.pos ?? { x: 0, y: 0, z: 1, d: 1 },
            thrownError: null,
            isDragging: false,
            dragStartCoords: null,
            titlebarClickTimestamp: -1,
            resizing: false,
            opacity: 0,
            isMaximized: this.props.isMaximized ?? false,
            isMinimized: this.props.isMinimized ?? false,
            transform: null,
            onResize: this.props.onResize ?? undefined,
            onFocus: this.props.onFocus ?? undefined,
        };
        state.preMaximMinimSize = this.props.preMaximMinimSize ?? state.size;
        state.preMaximMinimPos = this.props.preMaximMinimPos ?? state.pos;
        state.sizeDef = this.props.sizeDef ?? state.size;
        const validatedState = this.validatePosSize(state);
        validatedState.dragStartCoords = null;
        if (validatedState.onResize === null) {
            validatedState.onResize = undefined;
        }
        if (validatedState.onFocus === null) {
            validatedState.onFocus = undefined;
        }
        this.state = validatedState;
    }
    updateChildState(newState) {
        this.setState({ childState: newState });
    }
    static getDerivedStateFromError(error) {
        return { thrownError: error };
    }
    componentDidCatch(err, info) {
        console.error(err);
        console.warn(info);
    }
    componentDidMount() {
        this.applyResizer();
        this.SetOpacity(undefined);
    }
    applyResizer() {
        if (this.rootEl.current == null) {
            return;
        }
        const $el = $(this.rootEl.current);
        $el.resizable({
            containment: 'parent',
            handles: 'n, e, s, w, ne, se, sw, nw',
            minHeight: this.state.sizeMin.y,
            minWidth: this.state.sizeMin.x,
            maxHeight: this.state.sizeMax.y,
            maxWidth: this.state.sizeMax.x,
            grid: [1, 1],
            start: () => {
                this.Focus();
                this.update(() => ({ resizing: true }));
            },
            resize: () => this.onResizeEvent(),
            stop: () => {
                const results = {
                    left: $el.css('left'),
                    top: $el.css('top'),
                    width: $el.width(),
                    height: $el.height(),
                };
                this.update(() => ({
                    resizing: false,
                    pos: {
                        x: parseInt(results.left, 10),
                        y: parseInt(results.top, 10),
                        z: this.state.pos.z,
                        d: this.state.pos.d,
                    },
                    preMaximMinimPos: {
                        x: parseInt(results.left, 10),
                        y: parseInt(results.top, 10),
                        z: this.state.pos.z,
                        d: this.state.pos.d,
                    },
                    size: {
                        x: Math.round(results.width),
                        y: Math.round(results.height),
                    },
                }));
                this.onFocus();
            },
        });
    }
    render() {
        return (React.createElement("div", { className: Do(() => {
                let C = this.props.cl ?? '';
                C += ' window ui-resizable react';
                if (this.props.isFocused) {
                    C += ' focus';
                }
                if (this.state.resizing) {
                    C += ' resizing';
                }
                if (this.state.isDragging) {
                    C += ' dragging';
                }
                if (this.state.isMinimized) {
                    C += ' minim';
                }
                if (this.state.isMaximized) {
                    C += ' maxim';
                }
                if (this.isHidingWindow()) {
                    C += ' hide';
                }
                return C;
            }), ref: this.rootEl, tabIndex: 1, style: Do(() => {
                const hidden = this.isHidingWindow();
                const styles = Do(() => {
                    if (window.innerWidth > 490) {
                        return {
                            top: this.state.pos.y,
                            left: this.state.pos.x,
                            height: this.state.size.y,
                            width: this.state.size.x,
                        };
                    }
                    return {
                        top: 0,
                        left: 0,
                        height: '100%',
                        width: '100%',
                    };
                });
                return {
                    ...styles,
                    zIndex: this.state.pos.z,
                    transform: this.state.transform ?? undefined,
                    opacity: !hidden ? this.state.opacity : undefined,
                };
            }), onClick: this.Focus },
            this.buildTitlebar(),
            this.buildWindowContent(),
            this.buildDraggingModal()));
    }
    isHidingWindow() {
        const is_mobile = window.innerWidth < 768;
        const on_another_desktop = this.props.parent.state.desktop !== this.state.pos.d;
        if (!is_mobile && on_another_desktop) {
            return true;
        }
        return false;
    }
    isHidingContent() {
        const is_mobile = window.innerWidth < 768;
        const on_another_desktop = this.props.parent.state.desktop !== this.state.pos.d;
        if (this.state.isMinimized) {
            return true;
        }
        if (is_mobile && !this.props.isFocused) {
            return true;
        }
        if (!is_mobile && on_another_desktop) {
            return true;
        }
        return false;
    }
    onResizeEventProc() {
        this.contentComponent.current?.Update();
        (this.state.onResize ?? _.noop)(this);
    }
    buildWindowContent() {
        return (React.createElement("div", { key: "content", className: "content" }, Do(() => {
            if (this.isHidingContent()) {
                return null;
            }
            if (this.props.isLoading) {
                return (React.createElement(React.Fragment, null,
                    React.createElement(LoadingSpinnerLarge, null)));
            }
            if (this.state.thrownError) {
                return (React.createElement(React.Fragment, null,
                    React.createElement("div", { className: "content" },
                        React.createElement("div", { className: "error_msg_2 cntr" }, "Unexpected error - re-open or refresh?"))));
            }
            const content = this.props.parent.cachedFunctions[this.props.content] ?? _.noop;
            const contentParams = {
                ...content(this.state.params ?? {}, this),
                window: this,
                key: 'content-inner',
                ref: this.contentComponent,
                lastForcedReactUpdate: window.lastForcedReactUpdate,
            };
            contentParams.tagProxy = contentParams.tag;
            contentParams.tag = WindowManagerWindowContentWrapper;
            return React.createElement(React.Fragment, null, j2r(contentParams));
        })));
    }
    buildTitlebar() {
        const title = this.getTitle();
        return (React.createElement("div", { key: "titlebar", className: "titlebar", onContextMenu: this.contextMenuTitlebar, onMouseDown: this.dragStart, onTouchStart: this.dragStart, onTouchMove: this.dragEvent, onTouchEnd: this.dragEnd },
            React.createElement("div", { className: "title", title: title }, title),
            React.createElement(HelpTooltip, { title: "Options" },
                React.createElement("div", { className: "kebab icon", onClick: this.kebabClick, onMouseDown: e => {
                        e.stopPropagation();
                    } },
                    React.createElement("img", { src: "/static/img/svg/wmanage/kebab.svg" }))),
            React.createElement(HelpTooltip, { title: "Minimize Window" },
                React.createElement("div", { className: "minim icon", onMouseDown: e => {
                        e.stopPropagation();
                    }, onClick: () => {
                        this.minimize();
                    } },
                    React.createElement("img", { src: "/static/img/svg/wmanage/minimize.svg" }))),
            React.createElement(HelpTooltip, { title: "Maximize Window" },
                React.createElement("div", { className: "maxim icon", onMouseDown: e => {
                        e.stopPropagation();
                    }, onClick: () => {
                        this.maximizeRestore();
                        this.onFocus();
                    } },
                    React.createElement("img", { src: this.state.isMaximized
                            ? '/static/img/svg/wmanage/restore.svg'
                            : '/static/img/svg/wmanage/maximize.svg' }))),
            React.createElement(HelpTooltip, { title: "Close Window" },
                React.createElement("div", { className: "close icon", onMouseDown: e => {
                        e.stopPropagation();
                    }, onClick: this.Close },
                    React.createElement("img", { src: "/static/img/svg/wmanage/cross.svg" })))));
    }
    dragStart(e) {
        e.stopPropagation();
        if (window.innerWidth < 768) {
            return;
        }
        const isMouseEvent = 'button' in e;
        const isTouchEvent = 'touches' in e;
        if (isMouseEvent && e.button !== 0 && !isTouchEvent) {
            return;
        }
        const diff = Date.now() - this.state.titlebarClickTimestamp;
        if (diff < 500) {
            this.maximizeRestore();
            this.onFocus();
            return;
        }
        this.Focus();
        let x = 0;
        let y = 0;
        if (isMouseEvent) {
            x = e.clientX;
            y = e.clientY;
        }
        else if (isTouchEvent) {
            x = e.changedTouches[0]?.clientX ?? 0;
            y = e.changedTouches[0]?.clientY ?? 0;
        }
        this.setState({
            isDragging: true,
            dragStartCoords: { x, y },
            titlebarClickTimestamp: Date.now(),
        });
        window.addEventListener('mouseup', this.dragEnd);
        window.addEventListener('mousemove', this.dragEvent);
    }
    dragEvent(e) {
        e.stopPropagation();
        if (this.state.dragStartCoords == null) {
            return;
        }
        const isMouseEvent = 'clientX' in e;
        const isTouchEvent = 'changedTouches' in e;
        let x = 0;
        let y = 0;
        if (isMouseEvent) {
            x = e.clientX;
            y = e.clientY;
        }
        else if (isTouchEvent) {
            x = e.changedTouches[0]?.clientX ?? 0;
            y = e.changedTouches[0]?.clientY ?? 0;
        }
        const dx = x - this.state.dragStartCoords.x;
        const dy = y - this.state.dragStartCoords.y;
        const nx = this.state.pos.x + dx;
        const ny = this.state.pos.y + dy;
        if (this.rootEl.current != null) {
            this.rootEl.current.style.left = `${nx}px`;
            this.rootEl.current.style.top = `${ny}px`;
        }
    }
    dragEnd(e) {
        e.stopPropagation();
        window.removeEventListener('mouseup', this.dragEnd);
        window.removeEventListener('mousemove', this.dragEvent);
        const isMouseEvent = 'clientX' in e;
        const isTouchEvent = 'changedTouches' in e;
        let x = 0;
        let y = 0;
        if (isMouseEvent) {
            x = e.clientX;
            y = e.clientY;
        }
        else if (isTouchEvent) {
            x = e.changedTouches[0]?.clientX ?? 0;
            y = e.changedTouches[0]?.clientY ?? 0;
        }
        const new_pos = {
            x: this.state.pos.x + x - (this.state.dragStartCoords?.x ?? 0),
            y: this.state.pos.y + y - (this.state.dragStartCoords?.y ?? 0),
            d: this.state.pos.d,
            z: this.state.pos.z,
        };
        let newTs = this.state.titlebarClickTimestamp;
        const Dx = (new_pos.x - this.state.pos.x) ** 2;
        const Dy = (new_pos.y - this.state.pos.y) ** 2;
        const distance = Math.sqrt(Dx + Dy);
        if (distance > 5) {
            newTs = -1;
        }
        if (this.rootEl.current != null) {
            this.rootEl.current.style.transform = '';
        }
        this.update(() => ({
            isDragging: false,
            dragStartCoords: null,
            titlebarClickTimestamp: newTs,
            resizing: false,
            pos: new_pos,
            preMaximMinimPos: new_pos,
        }));
        this.Focus();
    }
    buildDraggingModal() {
        return (React.createElement(Modal, { key: "dragging-modal" },
            React.createElement(CJSX, { cond: this.state.isDragging },
                React.createElement("div", { className: "dragging-modal", onMouseMove: this.dragEvent, onTouchMove: this.dragEvent, onMouseUp: this.dragEnd, onTouchEnd: this.dragEnd }))));
    }
    update(deltaFn, cb) {
        if (!_.isFunction(deltaFn)) {
            console.error('Invalid delta for window `update`:', deltaFn);
            return;
        }
        const deltaFnWrapped = (s) => {
            const delta = deltaFn(s);
            if (delta.size != null) {
                delta.size = {
                    x: delta.size.x ?? s.size.x,
                    y: delta.size.y ?? s.size.y,
                };
            }
            if (delta.sizeMax != null) {
                delta.sizeMax = {
                    x: delta.sizeMax.x ?? s.sizeMax.x,
                    y: delta.sizeMax.y ?? s.sizeMax.y,
                };
            }
            if (delta.sizeMin != null) {
                delta.sizeMin = {
                    x: delta.sizeMin.x ?? s.sizeMin.x,
                    y: delta.sizeMin.y ?? s.sizeMin.y,
                };
            }
            if (delta.sizeDef != null) {
                delta.sizeDef = {
                    x: delta.sizeDef.x ?? s.sizeDef.x,
                    y: delta.sizeDef.y ?? s.sizeDef.y,
                };
            }
            if (delta.pos != null) {
                delta.pos = {
                    x: delta.pos.x ?? s.pos.x,
                    y: delta.pos.y ?? s.pos.y,
                    z: delta.pos.z ?? s.pos.z,
                    d: delta.pos.d ?? s.pos.d,
                };
            }
            if (delta.pos == null) {
                delete delta.pos;
            }
            if (delta.size == null) {
                delete delta.size;
            }
            if (delta.sizeMin == null) {
                delete delta.sizeMin;
            }
            if (delta.sizeMax == null) {
                delete delta.sizeMax;
            }
            if (delta.sizeDef == null) {
                delete delta.sizeDef;
            }
            const has_resized = delta.size != null && !_.isEqual(delta.size, s.size);
            if (has_resized) {
                this.onResizeEvent();
                timer(250, () => this.onResizeEvent());
            }
            const final_diff = {};
            const diffKeys = _.keys(objDiff(delta, s));
            for (const k of diffKeys) {
                const key = k;
                const value = delta[key];
                if (value !== undefined && key in s) {
                    ;
                    final_diff[key] = value;
                }
            }
            return final_diff;
        };
        this.checkNotNeeded = false;
        this.setState(prevState => {
            const partial = deltaFnWrapped(prevState);
            return { ...prevState, ...partial };
        }, () => {
            this.ConfirmValidPosSize();
            (cb ?? _.noop)();
            this.props.parent.Update();
        });
    }
    validatePosSize(state, skip_max_check) {
        if (skip_max_check == null) {
            skip_max_check = false;
        }
        const S = _.cloneDeep(state);
        if (S.pos == null) {
            S.pos = { x: 0, y: 0, z: 0, d: 1 };
        }
        if (S.size == null) {
            S.size = { x: 0, y: 0 };
        }
        if (S.pos.x == null) {
            S.pos.x = this.state.pos.x;
        }
        if (S.pos.y == null) {
            S.pos.y = this.state.pos.y;
        }
        if (S.pos.z == null) {
            S.pos.z = this.state.pos.z;
        }
        if (S.pos.d == null) {
            S.pos.d = this.state.pos.d;
        }
        if (S.size.x == null) {
            S.size.x = this.state.sizeDef.x;
        }
        if (S.size.y == null) {
            S.size.y = this.state.sizeDef.y;
        }
        const canvas = this.props.parent.GetCanvasSize();
        if (S.size.x > canvas.x) {
            S.size.x = canvas.x;
        }
        if (S.size.y > canvas.y) {
            S.size.y = canvas.y;
        }
        if (S.size.x > S.sizeMax.x) {
            S.size.x = S.sizeMax.x;
        }
        if (S.size.y > S.sizeMax.y) {
            S.size.y = S.sizeMax.y;
        }
        if (!S.isMinimized) {
            if (S.size.x < S.sizeMin.x) {
                S.size.x = S.sizeMin.x;
            }
            if (S.size.y < S.sizeMin.y) {
                S.size.y = S.sizeMin.y;
            }
        }
        if (S.pos.x + S.size.x > canvas.x) {
            S.pos.x = canvas.x - S.size.x;
        }
        if (S.pos.y + S.size.y > canvas.y) {
            S.pos.y = canvas.y - S.size.y;
        }
        if (S.pos.x < 0) {
            S.pos.x = 0;
        }
        if (S.pos.y < 0) {
            S.pos.y = 0;
        }
        if (!skip_max_check) {
            let hypothetical_state = _.assign({}, S, { size: S.sizeMax });
            hypothetical_state = this.validatePosSize(hypothetical_state, true);
            S.isMaximized = _.isEqual(S.size, hypothetical_state.size) && !S.isMinimized;
        }
        return S;
    }
    maximizeRestore() {
        if (!this.state.isMaximized && !this.state.isMinimized) {
            this.update(s => ({
                isMinimized: false,
                isMaximized: true,
                size: s.sizeMax,
                pos: s.pos,
                preMaximMinimSize: !s.isMinimized ? s.size : undefined,
                preMaximMinimPos: s.pos,
            }));
        }
        else {
            this.update(s => ({
                isMinimized: false,
                isMaximized: false,
                size: Do(() => {
                    if (_.isEqual(s.preMaximMinimSize, s.size)) {
                        return s.sizeDef;
                    }
                    return s.preMaximMinimSize ?? s.sizeDef;
                }),
                pos: _.assign({}, s.preMaximMinimPos ?? s.pos, {
                    z: s.pos.z,
                    d: s.pos.d,
                }),
                preMaximMinimSize: !s.isMinimized ? s.size : undefined,
                preMaximMinimPos: s.pos,
            }));
        }
    }
    minimize(pos) {
        if (this.state.isMinimized) {
            return;
        }
        this.update(s => ({
            isMinimized: !s.isMinimized,
            isMaximized: false,
            size: {
                x: 200,
                y: 28,
            },
            pos: Do(() => {
                pos = pos ?? this.props.parent.getMinimizeCoords(1)[0];
                return _.assign({}, pos, {
                    z: s.pos.z,
                    d: s.pos.d,
                });
            }),
            preMaximMinimSize: !s.isMaximized ? s.size : undefined,
            preMaximMinimPos: s.pos,
        }));
    }
    setToDefaultSize() {
        this.update(() => ({ size: this.state.sizeDef }));
    }
    kebabClick() {
        const el = this.rootEl.current?.querySelector('.kebab.icon');
        if (el == null) {
            return;
        }
        const rect = el.getBoundingClientRect();
        this.openKebabMenu({
            x: (rect.right + rect.left) / 2,
            y: (rect.top + rect.bottom) / 2,
        });
    }
    contextMenuTitlebar(e) {
        e.preventDefault();
        e.stopPropagation();
        this.openKebabMenu({
            x: e.clientX,
            y: e.clientY,
        });
    }
    openKebabMenu({ x, y }) {
        setContextMenu({
            position: { x, y },
            width: 160,
            items: _.compact([
                {
                    label: 'Default Size',
                    onClick: () => {
                        this.setToDefaultSize();
                        this.onFocus();
                    },
                },
                {
                    label: 'Snap to',
                    childWidth: 160,
                    items: [
                        {
                            label: 'Left-hand side',
                            onClick: () => {
                                this.snap('left');
                                this.onFocus();
                            },
                        },
                        {
                            label: 'Right-hand side',
                            onClick: () => {
                                this.snap('right');
                                this.onFocus();
                            },
                        },
                    ],
                },
                ConditionalObject(!this.props.parent.props.options.disableVirtualDesktops, {
                    label: 'Move to',
                    childWidth: 160,
                    items: this.props.parent.state.desktops.map((x) => ({
                        label: x.name ?? `Desktop ${x.index}`,
                        onClick: () => {
                            const delta = () => ({ pos: { d: x.key } });
                            this.update(delta, () => this.props.parent.ChangeDesktop(x.key));
                            this.onFocus();
                        },
                    })),
                }),
                '---',
                {
                    label: 'Minimise',
                    icon: '/static/img/svg/wmanage/minimize.svg',
                    iconGrayscale: true,
                    onClick: () => {
                        this.minimize();
                    },
                },
                {
                    label: this.state.isMaximized ? 'Restore' : 'Maximise',
                    icon: Do(() => {
                        const f = this.state.isMaximized ? 'restore' : 'maximize';
                        return `/static/img/svg/wmanage/${f}.svg`;
                    }),
                    iconGrayscale: true,
                    onClick: () => {
                        this.maximizeRestore();
                        this.onFocus();
                    },
                },
                {
                    label: 'Close',
                    icon: '/static/img/svg/wmanage/cross.svg',
                    iconGrayscale: true,
                    onClick: this.Close,
                },
            ]),
        });
    }
    snap(dir) {
        const sizeMax = this.props.sizeMax ?? { x: 99999, y: 99999 };
        const width = Math.min(sizeMax.x, window.innerWidth / 2);
        const left = Do(() => {
            if (dir === 'left') {
                return 0;
            }
            else if (dir === 'right') {
                return window.innerWidth - width;
            }
            console.error('Invalid snap direction');
            return 0;
        });
        this.update(() => ({
            isMinimized: false,
            isMaximized: false,
            pos: {
                x: left,
                y: 0,
                z: this.state.pos.z,
                d: this.state.pos.d,
            },
            preMaximMinimPos: {
                x: left,
                y: 0,
                z: this.state.pos.z,
                d: this.state.pos.d,
            },
            size: {
                x: width,
                y: sizeMax.y,
            },
        }));
    }
    onFocus() {
        if (this.props.onFocus != null) {
            this.props.onFocus(this.GetContent(), this);
        }
    }
    getTitle() {
        const titleKey = this.props.title;
        if (titleKey == null) {
            return 'Loading...';
        }
        const titleFn = this.props.parent.cachedFunctions[titleKey];
        if (_.isFunction(titleFn)) {
            return titleFn(this.state.params ?? {}, this) ?? 'Loading...';
        }
        const msg = 'ERROR: INVALID TITLE FORMAT - MUST BE A FUNCTION';
        console.error(msg);
        return msg;
    }
    Close() {
        const result = this.props.onClose?.(this.state.childState, this) ?? true;
        if (result !== false) {
            this.props.parent.CloseWindow(this.state.key);
        }
    }
    UpdateCreationState(obj = {}) {
        const C = this.GetContent();
        if (this.props.fields != null && C != null) {
            _.forEach(this.props.fields, f => {
                if (_.has(obj, f)) {
                    return;
                }
                let val = C.state?.[f];
                if (val === undefined) {
                    val = C.props?.[f];
                }
                if (val !== undefined) {
                    obj[f] = val;
                }
            });
        }
        obj = _.assign({}, this.state.params, obj);
        if (!_.isEqual(obj, this.state.params)) {
            const delta = () => ({ params: obj });
            this.setState(delta, () => this.props.parent.Update());
        }
    }
    ConfirmValidPosSize() {
        if (this.checkNotNeeded) {
            return;
        }
        this.update(() => this.validatePosSize(this.state));
        this.checkNotNeeded = true;
        timer(() => {
            this.checkNotNeeded = false;
        });
    }
    UpdatePositionSize(delta) {
        delta = _.isFunction(delta) ? delta() : delta;
        const { size, sizeDef, sizeMin, sizeMax, pos } = delta;
        const diff = () => ({
            pos: pos ?? undefined,
            size: size ?? undefined,
            sizeDef: sizeDef ?? undefined,
            sizeMin: sizeMin ?? undefined,
            sizeMax: sizeMax ?? undefined,
        });
        this.update(diff, () => {
            if (sizeMin != null || sizeMax != null) {
                this.applyResizer();
            }
        });
    }
    UpdateSID(newSID) {
        this.setState(() => ({ sid: newSID ?? null }));
    }
    GetContent() {
        return this.contentComponent.current?.CC.current ?? null;
    }
    Pulse() {
        const pulse = () => {
            this.rootEl.current?.classList.add('pulse');
            timer(200, () => this.rootEl.current?.classList.remove('pulse'));
        };
        if (this.state.isMinimized) {
            this.maximizeRestore();
            timer(200, () => {
                pulse();
            });
        }
        else {
            pulse();
        }
    }
    Focus() {
        if (!this.props.isFocused) {
            this.props.parent.ChangeFocus(this.state.key);
            this.onFocus();
        }
    }
    SetOpacity(lvl) {
        this.setState({ opacity: lvl });
    }
}
class WindowManagerWindowContentWrapper extends React.Component {
    CC;
    constructor(props) {
        super(props);
        this.CC = React.createRef();
    }
    shouldComponentUpdate(nextProps) {
        if (!_.isEqual(nextProps, this.props)) {
            return true;
        }
        return false;
    }
    render() {
        return j2r(() => {
            const tag = this.props.tagProxy;
            const params = _.omit(this.props, [
                'tag',
                'tagProxy',
                'ref',
            ]);
            console.log({ params });
            params['tag'] = tag;
            params['ref'] = this.CC;
            return params;
        });
    }
    Update() {
        this.forceUpdate();
    }
}
class DemoWindow extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            text: this.props.text ?? '',
            check: this.props.check ?? false,
        };
    }
    componentDidMount() {
        this.props.window.UpdateCreationState();
    }
    updateState(delta) {
        this.setState(delta, () => this.props.window.UpdateCreationState());
    }
    render() {
        return j2r({
            cl: 'example-window',
            children: [
                j2rProps(this, 'text', () => ({ tag: J2rText })),
                j2rProps(this, 'check', () => ({
                    tag: J2rCheckbox,
                    label: 'Checkbox',
                    triggerClick: true,
                })),
            ],
        });
    }
}
export const openDemoWindow = () => ({
    title: p => `Demo window - ${p.text} - ${p.check ? 1 : 0}`,
    size: [480, 360],
    func: 'openDemoWindow',
    cmpt: DemoWindow,
    fields: ['text', 'checkbox'],
});
export const openWindowAsFlyout = (fn, params) => {
    let obj;
    if (params == null) {
        params = {};
    }
    const properties = fn(params);
    if ('cmpt' in properties) {
        obj = { tag: properties.cmpt };
        _.forEach(params, (v, k) => {
            obj[k] = v;
        });
    }
    else if ('content' in properties) {
        const contentResult = properties.content(params);
        if (typeof contentResult === 'string' ||
            contentResult instanceof Element ||
            Array.isArray(contentResult) ||
            typeof contentResult === 'function') {
            throw new Error('Content must return a J2rObject');
        }
        obj = contentResult;
    }
    else {
        throw new Error('Windows need either `cmpt` or `content`');
    }
    let title = properties.title(params);
    const size = [
        properties.size[0] + 20,
        properties.size[1] + 20 + 42 - 28,
    ];
    let flyout = null;
    const windowObj = {
        Close: () => {
            if (flyout != null) {
                flyout.Close();
            }
        },
        UpdateSID: _.noop,
        UpdateCreationState: _.noop,
        UpdatePositionSize: (delta) => {
            if (flyout != null) {
                const d = delta();
                flyout.ChangeSize({
                    width: d.size?.x != null ? d.size.x + 20 : undefined,
                    height: d.size?.y != null ? d.size.y + 20 + 42 - 28 : undefined,
                    left: d.pos?.x ? d.pos.x : undefined,
                    top: d.pos?.y ? d.pos.y : undefined,
                });
            }
        },
    };
    Object.assign(obj, { window: windowObj, isInFlyout: true });
    title = properties.buildOwnTitleFlyoutMode ? '' : title;
    flyout = reactFlyout(title, size, obj);
    if (flyout.Element) {
        flyout.Element.classList.add('window-back-compat');
    }
};
//# sourceMappingURL=window-manager.js.map